// extracted by mini-css-extract-plugin
export var carouselArrowLeft = "carousel-transformer-module--carousel-arrow-left--90469";
export var carouselArrowRight = "carousel-transformer-module--carousel-arrow-right--e219b";
export var carouselImage = "carousel-transformer-module--carousel-image--cc8bf";
export var carouselTransformer = "carousel-transformer-module--carousel-transformer--08929";
export var modalButton = "carousel-transformer-module--modal-button--cec3f";
export var modalImage = "carousel-transformer-module--modal-image--d6d2e";